import React, { useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import About from "../components/About";
import Process from "../components/Process";
import HomePortfolio from "../components/HomePortfolio";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Home = () => {
  useEffect(() => {
    document.title = "RankifyDev | Website Development & SEO Services";
  }, []);

  return (
    <div className="App">
      <Header />

      <main>
        <Hero />
        <Services />
        <About />
        <Process />
        <HomePortfolio />
        <FAQ />
        <Contact />
      </main>

      <Footer />
    </div>
  );
};

export default Home;